module.exports = __webpack_public_path__ + "static/media/03.0fb59895.jpg";